import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useSelectedSort } from '@store/reducers/trend-research/TrendResearchReducer';

const useTrendResearchFilterParams = (removedParamList = ['instagramUserNameList']) => {
	const [requestBody, setRequestBody] = useState({});
	const filterData = useSelector((store) => store.filterFieldStore);
	const selectedSort = useSelectedSort();

	useEffect(() => {
		let splitDate = null;
		if (filterData?.dateRange?.[0]?.key && !removedParamList.includes('dateRange')) {
			let selectedDate = filterData?.dateRange?.[0]?.key;
			splitDate = selectedDate.split(',');
		}
		let tmpObject = {
			brandCodeList:
				filterData?.brandCodeList?.map((item) => item.key)?.filter((item) => item !== 'ALL') || [],
			categoryIdList:
				filterData?.categoryIdList?.map((item) => item.key)?.filter((item) => item !== 'ALL') || [],
			fabricTypeList: filterData?.supplierCategoryList?.map((item) => item.key) || [],
			fiberList: filterData?.fiberList?.map((item) => item.key) || [],
			graphicsContentList: filterData?.graphicsContentList?.map((item) => item.key) || [],
			graphicsTypeList: filterData?.graphicsTypeList?.map((item) => item.key) || [],
			marketIdList: filterData?.marketIds?.map((item) => item.key) || [],
			keyCompositionList: filterData?.keyCompositionList?.map((item) => item.key) || [],
			instagramUserNameList: filterData?.userNameList?.map((item) => item.key) || [],
			colorList: filterData?.colorList?.map((item) => item.key) || [],
			themeList: filterData?.themeList?.map((item) => item.key) || [],
			startDate: splitDate ? splitDate[0] : null,
			endDate: splitDate ? splitDate[1] : null,
			search: filterData?.trendResearchSearch?.[0]?.key || null,
			sortBy: selectedSort
		};

		tmpObject = Object.fromEntries(
			Object.entries(tmpObject).filter(
				([, value]) => !(Array.isArray(value) && value.length === 0) && value !== null
			)
		);
		setRequestBody(tmpObject);
	}, [filterData, selectedSort]);

	return { requestBody };
};

export default useTrendResearchFilterParams;
